import { useEffect } from "react";
import { useTheme } from "next-themes";

const FAVICON_VERSION = "2025-12-28-v9";

const withVersion = (path: string) => `${path}?v=${FAVICON_VERSION}`;

const useThemeFavicon = () => {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    if (!resolvedTheme) return;

    const isLight = resolvedTheme === "light";

    const upsertLink = (selector: string, nextHref: string, attrs?: Record<string, string>) => {
      const existing = document.querySelector(selector) as HTMLLinkElement | null;
      const link = document.createElement("link");

      if (existing) {
        Array.from(existing.attributes).forEach((a) => link.setAttribute(a.name, a.value));
      }

      if (attrs) {
        Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
      }

      link.setAttribute("href", nextHref);

      if (existing?.parentNode) {
        existing.parentNode.replaceChild(link, existing);
      } else {
        document.head.appendChild(link);
      }
    };

    upsertLink(
      'link[rel="icon"][type="image/x-icon"]',
      withVersion(isLight ? "/favicon-light.ico" : "/favicon-dark.ico"),
      { rel: "icon", type: "image/x-icon" }
    );

    upsertLink(
      'link[rel="shortcut icon"]',
      withVersion(isLight ? "/favicon-light.ico" : "/favicon-dark.ico"),
      { rel: "shortcut icon", type: "image/x-icon" }
    );

    upsertLink(
      'link[rel="apple-touch-icon"]',
      withVersion(isLight ? "/light-apple-touch-icon.png" : "/apple-touch-icon.png"),
      { rel: "apple-touch-icon", sizes: "180x180" }
    );
  }, [resolvedTheme]);
};

export default useThemeFavicon;
